import { Component, Input } from '@angular/core';
import { TranslationService } from '@sdbn/common';
import { Station } from 'src/tmc-yard/client/model/station';

@Component({
  selector: 'app-empty-workingarea-item',
  templateUrl: './empty-workingarea-item.component.html',
  styleUrls: ['./empty-workingarea-item.component.scss']
})
export class EmptyWorkingAreaItemComponent {

  @Input() station: Station;

  @Input() selected: boolean;

  constructor(
    public translationService: TranslationService
  ) {

  }

}
